// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iweb-toast-mask .iweb-toast-container {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  position: relative;
  width: fit-content;
  top: 60px;
  left: 50%;
  background: rgba(0, 0, 0, 0.6);
  transform: translate(-50%, 0);
  padding: 16px;
  min-width: 240px;
  max-width: 450px;
  max-height: 150px;
  line-height: 18px;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
}
.iweb-toast-mask .iweb-toast-title {
  font-weight: 600;
  font-size: 16px;
  line-height: 22px;
  color: #FFFFFF;
  margin: 0;
  margin-bottom: 12px;
  margin-right: auto;
}
.iweb-toast-mask .iweb-toast-wrap {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 4;
  overflow: hidden;
  margin: 0;
  color: white;
  word-break: break-word;
  pointer-events: all;
}
.iweb-toast-mask .iweb-toast-icon {
  margin-bottom: 12px;
  width: 30px;
  height: 30px;
}
.iweb-toast-mask .iweb-toast-icon-info {
  font-size: 30px;
  color: #2e71ff;
}
.iweb-toast-mask .iweb-toast-icon-warning {
  font-size: 30px;
  color: #f67f04;
}
.iweb-toast-mask .iweb-toast-icon-error {
  font-size: 30px;
  color: #e61413;
}
.iweb-toast-mask .iweb-toast-icon-success {
  font-size: 30px;
  color: #36b360;
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@ali/infinite-webui/es/web-components/Toast/toast.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,8BAA8B;EAC9B,6BAA6B;EAC7B,aAAa;EACb,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,mBAAmB;EACnB,kBAAkB;AACpB;AACA;EACE,oBAAoB;EACpB,4BAA4B;EAC5B,qBAAqB;EACrB,gBAAgB;EAChB,SAAS;EACT,YAAY;EACZ,sBAAsB;EACtB,mBAAmB;AACrB;AACA;EACE,mBAAmB;EACnB,WAAW;EACX,YAAY;AACd;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB;AACA;EACE,eAAe;EACf,cAAc;AAChB","sourcesContent":[".iweb-toast-mask .iweb-toast-container {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: center;\n  position: relative;\n  width: fit-content;\n  top: 60px;\n  left: 50%;\n  background: rgba(0, 0, 0, 0.6);\n  transform: translate(-50%, 0);\n  padding: 16px;\n  min-width: 240px;\n  max-width: 450px;\n  max-height: 150px;\n  line-height: 18px;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 20px;\n}\n.iweb-toast-mask .iweb-toast-title {\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 22px;\n  color: #FFFFFF;\n  margin: 0;\n  margin-bottom: 12px;\n  margin-right: auto;\n}\n.iweb-toast-mask .iweb-toast-wrap {\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n  -webkit-line-clamp: 4;\n  overflow: hidden;\n  margin: 0;\n  color: white;\n  word-break: break-word;\n  pointer-events: all;\n}\n.iweb-toast-mask .iweb-toast-icon {\n  margin-bottom: 12px;\n  width: 30px;\n  height: 30px;\n}\n.iweb-toast-mask .iweb-toast-icon-info {\n  font-size: 30px;\n  color: #2e71ff;\n}\n.iweb-toast-mask .iweb-toast-icon-warning {\n  font-size: 30px;\n  color: #f67f04;\n}\n.iweb-toast-mask .iweb-toast-icon-error {\n  font-size: 30px;\n  color: #e61413;\n}\n.iweb-toast-mask .iweb-toast-icon-success {\n  font-size: 30px;\n  color: #36b360;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
